<!-- Builder Start -->
<div id="{{position}}" *ngIf="!loading" class="position-relative">
  <div id="Reservation" *ngIf="(reservationSuccess$ | async) as reservationSuccess">
    <header class="app-header-background pb-40"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''"
      [attr.data-aos]="allElementAnimation ? allElementAnimation : null">
      <div class="app-header-section">
        <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start">
          <div fxFlex [fxFlexOrder]="imagePosition == 'right' ? 1 : 2" fxFlex.lt-sm="100%"
            [attr.data-aos]="textAnimation ? textAnimation : null" data-aos-duration="1100">
            <div class="app-header-headline">
              <h1 [style.textAlign]="textAlign" [class]="titleSize + ' mat-h1'"
                [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight':fontWeight }"
                [innerHtml]="title | safeHtml"></h1>
              <h2 [class]="textSize" [style.textAlign]="textAlign" [ngStyle]="{ 'color': textColor }"
                [innerHtml]="text | safeHtml"></h2>
            </div>
            <div class="second-step" *ngIf="secondStep">
              <div style="margin-bottom: 20px; font-size: 22px; font-weight: 500;"> {{secondeStepReservationTitle}} :
              </div>
              <div class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  event</mat-icon> {{dateParty | date:'EEEE , MMMM dd'}} - {{selectedTime}}
              </div>
              <div class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  done</mat-icon> {{partyInputText ? partyInputText+' of '+party+' - ' : ''}} {{selectedCategory}}
              </div>
              <div *ngIf="reservationSuccess == 'Success'" class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  person</mat-icon> {{nameReservation}}
              </div>
              <div *ngIf="reservationSuccess == 'Success'" class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  phone</mat-icon> {{phoneReservation}}
              </div>
              <div *ngIf="reservationSuccess == 'Success'" class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  email</mat-icon> {{emailReservation}}
              </div>
              <div *ngIf="reservationSuccess == 'Success' && specialRequestText" class="reservation-detail">
                <mat-icon style="font-size: 25px !important; vertical-align: bottom; margin-right: 12px;" class="icon">
                  message</mat-icon> {{specialRequestReservation}}
              </div>
              <div *ngIf="reservationSuccess == 'Failed'"
                style="margin-bottom: 20px; margin-top: 30px; font-size: 22px; font-weight: 500;">
                {{secondeStepContactInfoTitle}} :</div>
              <div class="contact-info" style="margin-bottom: 15px;margin-left: 15px;">
                <div *ngIf="reservationSuccess == 'Failed'">
                  <mat-form-field style="width: 100% !important;">
                    <input [(ngModel)]="nameReservation" matInput>
                    <mat-label>{{fullNameText}}</mat-label>
                  </mat-form-field>
                  <mat-form-field style="width: 100% !important;">
                    <input [(ngModel)]="phoneReservation" matInput>
                    <mat-label>{{phoneNumberText}}</mat-label>
                  </mat-form-field>
                  <mat-form-field style="width: 100% !important;">
                    <input [(ngModel)]="emailReservation" matInput>
                    <mat-label>{{emailAddressText}}</mat-label>
                  </mat-form-field>
                  <mat-form-field style="width: 100% !important;">
                    <textarea [(ngModel)]="specialRequestReservation" matInput></textarea>
                    <mat-label>{{specialRequestText}} (optional)</mat-label>
                  </mat-form-field>
                </div>
                <div *ngIf="reservationSuccess == 'Failed'" style="margin-top: 15px; text-align: left;"
                  class="app-header-start">
                  <a style="width: 200px;padding: 8px 5px;font-size: 18px;" class="app-button mat-raised-button"
                    mat-raised-button="" rel="noopener" tabindex="0" aria-disabled="false" (click)="reserveNow()"
                    target="_blank">
                    <span class="mat-button-wrapper"> {{ buttonText }} </span>
                  </a>
                </div>
                <div class="success-msg" *ngIf="reservationSuccess == 'Success'">
                  <br>
                  <br>
                  {{successMsg}}
                </div>
              </div>
            </div>
            <div *ngIf="!secondStep" style="margin-bottom: 40px;">
              <div class="form-date">
                <div *ngIf="partyInputText" class="party-filter">
                  <mat-form-field>
                    <mat-label>{{partyInputText}}</mat-label>
                    <mat-select [(ngModel)]="party" (selectionChange)="onChangeFimter()">
                      <mat-option [value]="1">1</mat-option>
                      <mat-option [value]="2">2</mat-option>
                      <mat-option [value]="3">3</mat-option>
                      <mat-option [value]="4">4</mat-option>
                      <mat-option [value]="5">5</mat-option>
                      <mat-option [value]="6">6</mat-option>
                      <mat-option [value]="7">7</mat-option>
                      <mat-option [value]="8">8</mat-option>
                      <mat-option [value]="9">9</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="date-filter">
                  <mat-form-field appearance="fill">
                    <mat-label>{{dateInputText}}</mat-label>
                    <input [(ngModel)]="dateParty" matInput [matDatepicker]="picker" (click)="picker.open()"
                      (dateChange)="onChangeFimter('dateParty')" [min]="todayDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="time-filter">
                  <mat-form-field>
                    <mat-label>{{timeInputText}}</mat-label>
                    <mat-select [(ngModel)]="time" (selectionChange)="onChangeFimter()">
                      <mat-option *ngFor="let time of timingAvailabilityToday" [value]="time">{{time}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="clear-float"></div>
              <div *ngIf="!dateParty" style="line-height: 20px;letter-spacing: 2px;margin-top: 40px;">
                <h2 class="title-opening-time">Opening time <mat-icon (click)="displayTimingAction()"
                    class="display-timing">{{displayTiming?'arrow_drop_up':'arrow_drop_down'}}</mat-icon>
                </h2>
                <div style="margin-left: 40px;margin-top: 30px;" *ngIf="displayTiming">
                  <div class="availabilityWeeklySchedule" *ngFor="let availabilityDay of availabilityWeeklySchedule">
                    <span style="font-weight: 600;">{{availabilityDay.day}}</span> : <span
                      *ngIf="availabilityDay.availability.length<=0">Closed</span> <span style="font-size: 14px;"
                      *ngFor="let timing of availabilityDay.availability;let i = index"> {{ i != 0 ? '|' :'' }} {{
                      timing.from }} - {{ timing.to }} </span>
                  </div>
                </div>
              </div>
              <div *ngIf="dateParty && !noItemFound">
                <div *ngFor="let category of categories">
                  <div *ngIf="category.timingList.length>0" class="category-title">{{category.name}}</div>
                  <div *ngFor="let timing of category.timingList" class="timing"
                    (click)="selectTime(timing,category.name)"
                    [ngClass]="timing == selectedTime && category.name == selectedCategory?'selected-timing':''">
                    {{ timing }}
                  </div>
                  <div class="clear-float"></div>
                </div>
              </div>
              <div class="no-item-found" *ngIf="noItemFound">
                No time available at this date
              </div>
            </div>
            <div [style.textAlign]="textAlign" class="app-header-start"
              *ngIf="buttonText && dateParty && !noItemFound && !secondStep">
              <a style="width: 200px;padding: 8px 5px;font-size: 18px;" class="app-button mat-raised-button"
                mat-raised-button="" rel="noopener" tabindex="0" aria-disabled="false" (click)="nextStep()"
                target="_blank">
                <span class="mat-button-wrapper"> {{ buttonText }} </span>
              </a>
            </div>
          </div>
          <div [fxFlexOrder]="imagePosition == 'right' ? 2 : 1" fxFlex fxFlexOrder="1" fxFlex.lt-sm="100%"
            [attr.data-aos]="imageAnimation ? imageAnimation : null">
            <div class="feature-image">
              <div class="feature-image-inner">
                <img [ngStyle]="{ 'border-radius': borderRadius+'px'}" [src]="picture" class="hero-image" [alt]="title" (error)="updateUrl($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</div>